import { createReducer } from 'util/reducers';

import {
  LOAD_MY_BOARDS_ERROR,
  LOAD_MY_BOARDS_REQUEST,
  LOAD_MY_BOARDS_SUCCESS,
} from 'modules/loaders';

// Reducer
export interface BoardSelectorState {
  loading: boolean;
}

const initialState: BoardSelectorState = {
  loading: false,
};

export default createReducer(initialState, {
  [LOAD_MY_BOARDS_REQUEST](state: BoardSelectorState) {
    return {
      ...state,
      loading: true,
    };
  },

  [LOAD_MY_BOARDS_SUCCESS](state: BoardSelectorState) {
    return {
      ...state,
      loading: false,
    };
  },

  [LOAD_MY_BOARDS_ERROR](state: BoardSelectorState) {
    return {
      ...state,
      loading: false,
    };
  },
});



// WEBPACK FOOTER //
// ./app/gamma/src/modules/state/ui/board-selector.ts